'use client';
"use strict";

var _excluded = ["preset", "motionProps"],
    _excluded2 = ["className", "children", "containerProps", "motionProps"],
    _excluded3 = ["className"],
    _excluded4 = ["onClick", "className"],
    _excluded5 = ["className"],
    _excluded6 = ["className"],
    _excluded7 = ["className", "transition", "motionProps"],
    _excluded8 = ["leastDestructiveRef"],
    _excluded9 = ["isOpen", "onClose", "placement", "children"],
    _excluded10 = ["className", "children", "motionProps", "containerProps"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __export = function __export(target, all) {
  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return to;
};

var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, _typeof(key) !== "symbol" ? key + "" : key, value);

  return value;
}; // src/index.ts


var src_exports = {};

__export(src_exports, {
  AlertDialog: function AlertDialog() {
    return _AlertDialog;
  },
  AlertDialogBody: function AlertDialogBody() {
    return _ModalBody;
  },
  AlertDialogCloseButton: function AlertDialogCloseButton() {
    return _ModalCloseButton;
  },
  AlertDialogContent: function AlertDialogContent() {
    return _AlertDialogContent;
  },
  AlertDialogFooter: function AlertDialogFooter() {
    return _ModalFooter;
  },
  AlertDialogHeader: function AlertDialogHeader() {
    return _ModalHeader;
  },
  AlertDialogOverlay: function AlertDialogOverlay() {
    return _ModalOverlay;
  },
  Drawer: function Drawer() {
    return _Drawer;
  },
  DrawerBody: function DrawerBody() {
    return _ModalBody;
  },
  DrawerCloseButton: function DrawerCloseButton() {
    return _ModalCloseButton;
  },
  DrawerContent: function DrawerContent() {
    return _DrawerContent;
  },
  DrawerFooter: function DrawerFooter() {
    return _ModalFooter;
  },
  DrawerHeader: function DrawerHeader() {
    return _ModalHeader;
  },
  DrawerOverlay: function DrawerOverlay() {
    return _ModalOverlay;
  },
  Modal: function Modal() {
    return _Modal;
  },
  ModalBody: function ModalBody() {
    return _ModalBody;
  },
  ModalCloseButton: function ModalCloseButton() {
    return _ModalCloseButton;
  },
  ModalContent: function ModalContent() {
    return _ModalContent;
  },
  ModalContextProvider: function ModalContextProvider() {
    return _ModalContextProvider;
  },
  ModalFocusScope: function ModalFocusScope() {
    return _ModalFocusScope;
  },
  ModalFooter: function ModalFooter() {
    return _ModalFooter;
  },
  ModalHeader: function ModalHeader() {
    return _ModalHeader;
  },
  ModalOverlay: function ModalOverlay() {
    return _ModalOverlay;
  },
  useDrawerContext: function useDrawerContext() {
    return _useDrawerContext;
  },
  useModal: function useModal() {
    return _useModal;
  },
  useModalContext: function useModalContext() {
    return _useModalContext;
  },
  useModalManager: function useModalManager() {
    return _useModalManager;
  },
  useModalStyles: function useModalStyles() {
    return _useModalStyles;
  }
});

module.exports = __toCommonJS(src_exports); // src/alert-dialog.tsx

var import_system9 = require("@chakra-ui/system"); // src/modal.tsx


var import_portal = require("@chakra-ui/portal");

var import_react_context = require("@chakra-ui/react-context");

var import_system = require("@chakra-ui/system");

var import_framer_motion = require("framer-motion"); // src/use-modal.ts


var import_shared_utils = require("@chakra-ui/shared-utils");

var import_react_use_merge_refs = require("@chakra-ui/react-use-merge-refs");

var import_aria_hidden = require("aria-hidden");

var import_react2 = require("react"); // src/modal-manager.ts


var import_react = require("react");

var ModalManager = /*#__PURE__*/function () {
  function ModalManager() {
    _classCallCheck(this, ModalManager);

    __publicField(this, "modals");

    this.modals = /* @__PURE__ */new Map();
  }

  _createClass(ModalManager, [{
    key: "add",
    value: function add(modal) {
      this.modals.set(modal, this.modals.size + 1);
      return this.modals.size;
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      this.modals.delete(modal);
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      if (!modal) return false;
      return this.modals.get(modal) === this.modals.size;
    }
  }]);

  return ModalManager;
}();

var modalManager = new ModalManager();

function _useModalManager(ref, isOpen) {
  var _ref = (0, import_react.useState)(0),
      _ref2 = _slicedToArray(_ref, 2),
      index = _ref2[0],
      setIndex = _ref2[1];

  (0, import_react.useEffect)(function () {
    var node = ref.current;
    if (!node) return;

    if (isOpen) {
      var index2 = modalManager.add(node);
      setIndex(index2);
    }

    return function () {
      modalManager.remove(node);
      setIndex(0);
    };
  }, [isOpen, ref]);
  return index;
} // src/use-modal.ts


function _useModal(props) {
  var isOpen = props.isOpen,
      onClose = props.onClose,
      id = props.id,
      _props$closeOnOverlay = props.closeOnOverlayClick,
      closeOnOverlayClick = _props$closeOnOverlay === void 0 ? true : _props$closeOnOverlay,
      _props$closeOnEsc = props.closeOnEsc,
      closeOnEsc = _props$closeOnEsc === void 0 ? true : _props$closeOnEsc,
      _props$useInert = props.useInert,
      useInert = _props$useInert === void 0 ? true : _props$useInert,
      onOverlayClickProp = props.onOverlayClick,
      onEsc = props.onEsc;
  var dialogRef = (0, import_react2.useRef)(null);
  var overlayRef = (0, import_react2.useRef)(null);

  var _useIds = useIds(id, "chakra-modal", "chakra-modal--header", "chakra-modal--body"),
      _useIds2 = _slicedToArray(_useIds, 3),
      dialogId = _useIds2[0],
      headerId = _useIds2[1],
      bodyId = _useIds2[2];

  useAriaHidden(dialogRef, isOpen && useInert);

  var index = _useModalManager(dialogRef, isOpen);

  var mouseDownTarget = (0, import_react2.useRef)(null);
  var onMouseDown = (0, import_react2.useCallback)(function (event) {
    mouseDownTarget.current = event.target;
  }, []);
  var onKeyDown = (0, import_react2.useCallback)(function (event) {
    if (event.key === "Escape") {
      event.stopPropagation();

      if (closeOnEsc) {
        onClose == null ? void 0 : onClose();
      }

      onEsc == null ? void 0 : onEsc();
    }
  }, [closeOnEsc, onClose, onEsc]);

  var _ref3 = (0, import_react2.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      headerMounted = _ref4[0],
      setHeaderMounted = _ref4[1];

  var _ref5 = (0, import_react2.useState)(false),
      _ref6 = _slicedToArray(_ref5, 2),
      bodyMounted = _ref6[0],
      setBodyMounted = _ref6[1];

  var getDialogProps = (0, import_react2.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({
      role: "dialog"
    }, props2), {}, {
      ref: (0, import_react_use_merge_refs.mergeRefs)(ref, dialogRef),
      id: dialogId,
      tabIndex: -1,
      "aria-modal": true,
      "aria-labelledby": headerMounted ? headerId : void 0,
      "aria-describedby": bodyMounted ? bodyId : void 0,
      onClick: (0, import_shared_utils.callAllHandlers)(props2.onClick, function (event) {
        return event.stopPropagation();
      })
    });
  }, [bodyId, bodyMounted, dialogId, headerId, headerMounted]);
  var onOverlayClick = (0, import_react2.useCallback)(function (event) {
    event.stopPropagation();
    if (mouseDownTarget.current !== event.target) return;
    if (!modalManager.isTopModal(dialogRef.current)) return;

    if (closeOnOverlayClick) {
      onClose == null ? void 0 : onClose();
    }

    onOverlayClickProp == null ? void 0 : onOverlayClickProp();
  }, [onClose, closeOnOverlayClick, onOverlayClickProp]);
  var getDialogContainerProps = (0, import_react2.useCallback)(function () {
    var props2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _objectSpread(_objectSpread({}, props2), {}, {
      ref: (0, import_react_use_merge_refs.mergeRefs)(ref, overlayRef),
      onClick: (0, import_shared_utils.callAllHandlers)(props2.onClick, onOverlayClick),
      onKeyDown: (0, import_shared_utils.callAllHandlers)(props2.onKeyDown, onKeyDown),
      onMouseDown: (0, import_shared_utils.callAllHandlers)(props2.onMouseDown, onMouseDown)
    });
  }, [onKeyDown, onMouseDown, onOverlayClick]);
  return {
    isOpen: isOpen,
    onClose: onClose,
    headerId: headerId,
    bodyId: bodyId,
    setBodyMounted: setBodyMounted,
    setHeaderMounted: setHeaderMounted,
    dialogRef: dialogRef,
    overlayRef: overlayRef,
    getDialogProps: getDialogProps,
    getDialogContainerProps: getDialogContainerProps,
    index: index
  };
}

function useAriaHidden(ref, shouldHide) {
  var currentElement = ref.current;
  (0, import_react2.useEffect)(function () {
    if (!ref.current || !shouldHide) return void 0;
    return (0, import_aria_hidden.hideOthers)(ref.current);
  }, [shouldHide, ref, currentElement]);
}

function useIds(idProp) {
  for (var _len = arguments.length, prefixes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    prefixes[_key - 1] = arguments[_key];
  }

  var reactId = (0, import_react2.useId)();
  var id = idProp || reactId;
  return (0, import_react2.useMemo)(function () {
    return prefixes.map(function (prefix) {
      return "".concat(prefix, "-").concat(id);
    });
  }, [id, prefixes]);
} // src/modal.tsx


var import_jsx_runtime = require("react/jsx-runtime");

var _ref7 = (0, import_react_context.createContext)({
  name: "ModalStylesContext",
  errorMessage: "useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in \"<Modal />\" "
}),
    _ref8 = _slicedToArray(_ref7, 2),
    ModalStylesProvider = _ref8[0],
    _useModalStyles = _ref8[1];

var _ref9 = (0, import_react_context.createContext)({
  strict: true,
  name: "ModalContext",
  errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
}),
    _ref10 = _slicedToArray(_ref9, 2),
    _ModalContextProvider = _ref10[0],
    _useModalContext = _ref10[1];

var _Modal = function _Modal(props) {
  var modalProps = _objectSpread({
    scrollBehavior: "outside",
    autoFocus: true,
    trapFocus: true,
    returnFocusOnClose: true,
    blockScrollOnMount: true,
    allowPinchZoom: false,
    motionPreset: "scale",
    lockFocusAcrossFrames: true
  }, props);

  var portalProps = modalProps.portalProps,
      children = modalProps.children,
      autoFocus = modalProps.autoFocus,
      trapFocus = modalProps.trapFocus,
      initialFocusRef = modalProps.initialFocusRef,
      finalFocusRef = modalProps.finalFocusRef,
      returnFocusOnClose = modalProps.returnFocusOnClose,
      blockScrollOnMount = modalProps.blockScrollOnMount,
      allowPinchZoom = modalProps.allowPinchZoom,
      preserveScrollBarGap = modalProps.preserveScrollBarGap,
      motionPreset = modalProps.motionPreset,
      lockFocusAcrossFrames = modalProps.lockFocusAcrossFrames,
      onCloseComplete = modalProps.onCloseComplete;
  var styles = (0, import_system.useMultiStyleConfig)("Modal", modalProps);

  var modal = _useModal(modalProps);

  var context = _objectSpread(_objectSpread({}, modal), {}, {
    autoFocus: autoFocus,
    trapFocus: trapFocus,
    initialFocusRef: initialFocusRef,
    finalFocusRef: finalFocusRef,
    returnFocusOnClose: returnFocusOnClose,
    blockScrollOnMount: blockScrollOnMount,
    allowPinchZoom: allowPinchZoom,
    preserveScrollBarGap: preserveScrollBarGap,
    motionPreset: motionPreset,
    lockFocusAcrossFrames: lockFocusAcrossFrames
  });

  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(_ModalContextProvider, {
    value: context,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(ModalStylesProvider, {
      value: styles,
      children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_framer_motion.AnimatePresence, {
        onExitComplete: onCloseComplete,
        children: context.isOpen && /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_portal.Portal, _objectSpread(_objectSpread({}, portalProps), {}, {
          children: children
        }))
      })
    })
  });
};

_Modal.displayName = "Modal"; // src/modal-content.tsx

var import_shared_utils2 = require("@chakra-ui/shared-utils");

var import_system3 = require("@chakra-ui/system"); // src/modal-focus.tsx


var import_focus_lock = require("@chakra-ui/focus-lock");

var import_framer_motion2 = require("framer-motion");

var import_react3 = require("react");

var import_react_remove_scroll = require("react-remove-scroll");

var import_jsx_runtime2 = require("react/jsx-runtime");

function _ModalFocusScope(props) {
  var _useModalContext2 = _useModalContext(),
      autoFocus = _useModalContext2.autoFocus,
      trapFocus = _useModalContext2.trapFocus,
      dialogRef = _useModalContext2.dialogRef,
      initialFocusRef = _useModalContext2.initialFocusRef,
      blockScrollOnMount = _useModalContext2.blockScrollOnMount,
      allowPinchZoom = _useModalContext2.allowPinchZoom,
      finalFocusRef = _useModalContext2.finalFocusRef,
      returnFocusOnClose = _useModalContext2.returnFocusOnClose,
      preserveScrollBarGap = _useModalContext2.preserveScrollBarGap,
      lockFocusAcrossFrames = _useModalContext2.lockFocusAcrossFrames,
      isOpen = _useModalContext2.isOpen;

  var _ref11 = (0, import_framer_motion2.usePresence)(),
      _ref12 = _slicedToArray(_ref11, 2),
      isPresent = _ref12[0],
      safeToRemove = _ref12[1];

  (0, import_react3.useEffect)(function () {
    if (!isPresent && safeToRemove) {
      setTimeout(safeToRemove);
    }
  }, [isPresent, safeToRemove]);

  var index = _useModalManager(dialogRef, isOpen);

  return /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_focus_lock.FocusLock, {
    autoFocus: autoFocus,
    isDisabled: !trapFocus,
    initialFocusRef: initialFocusRef,
    finalFocusRef: finalFocusRef,
    restoreFocus: returnFocusOnClose,
    contentRef: dialogRef,
    lockFocusAcrossFrames: lockFocusAcrossFrames,
    children: /* @__PURE__ */(0, import_jsx_runtime2.jsx)(import_react_remove_scroll.RemoveScroll, {
      removeScrollBar: !preserveScrollBarGap,
      allowPinchZoom: allowPinchZoom,
      enabled: index === 1 && blockScrollOnMount,
      forwardProps: true,
      children: props.children
    })
  });
} // src/modal-transition.tsx


var import_system2 = require("@chakra-ui/system");

var import_transition = require("@chakra-ui/transition");

var import_framer_motion3 = require("framer-motion");

var import_react4 = require("react");

var import_jsx_runtime3 = require("react/jsx-runtime");

var transitions = {
  slideInBottom: _objectSpread(_objectSpread({}, import_transition.slideFadeConfig), {}, {
    custom: {
      offsetY: 16,
      reverse: true
    }
  }),
  slideInRight: _objectSpread(_objectSpread({}, import_transition.slideFadeConfig), {}, {
    custom: {
      offsetX: 16,
      reverse: true
    }
  }),
  slideInTop: _objectSpread(_objectSpread({}, import_transition.slideFadeConfig), {}, {
    custom: {
      offsetY: -16,
      reverse: true
    }
  }),
  slideInLeft: _objectSpread(_objectSpread({}, import_transition.slideFadeConfig), {}, {
    custom: {
      offsetX: -16,
      reverse: true
    }
  }),
  scale: _objectSpread(_objectSpread({}, import_transition.scaleFadeConfig), {}, {
    custom: {
      initialScale: 0.95,
      reverse: true
    }
  }),
  none: {}
};
var MotionSection = (0, import_system2.chakra)(import_framer_motion3.motion.section);

var getMotionProps = function getMotionProps(preset) {
  return transitions[preset || "none"];
};

var ModalTransition = (0, import_react4.forwardRef)(function (props, ref) {
  var preset = props.preset,
      _props$motionProps = props.motionProps,
      motionProps = _props$motionProps === void 0 ? getMotionProps(preset) : _props$motionProps,
      rest = _objectWithoutProperties(props, _excluded);

  return /* @__PURE__ */(0, import_jsx_runtime3.jsx)(MotionSection, _objectSpread(_objectSpread({
    ref: ref
  }, motionProps), rest));
});
ModalTransition.displayName = "ModalTransition"; // src/modal-content.tsx

var import_jsx_runtime4 = require("react/jsx-runtime");

var _ModalContent = (0, import_system3.forwardRef)(function (props, ref) {
  var className = props.className,
      children = props.children,
      rootProps = props.containerProps,
      motionProps = props.motionProps,
      rest = _objectWithoutProperties(props, _excluded2);

  var _useModalContext3 = _useModalContext(),
      getDialogProps = _useModalContext3.getDialogProps,
      getDialogContainerProps = _useModalContext3.getDialogContainerProps;

  var dialogProps = getDialogProps(rest, ref);
  var containerProps = getDialogContainerProps(rootProps);

  var _className = (0, import_shared_utils2.cx)("chakra-modal__content", className);

  var styles = _useModalStyles();

  var dialogStyles = _objectSpread({
    display: "flex",
    flexDirection: "column",
    position: "relative",
    width: "100%",
    outline: 0
  }, styles.dialog);

  var dialogContainerStyles = _objectSpread({
    display: "flex",
    width: "100vw",
    height: "$100vh",
    position: "fixed",
    left: 0,
    top: 0
  }, styles.dialogContainer);

  var _useModalContext4 = _useModalContext(),
      motionPreset = _useModalContext4.motionPreset;

  return /* @__PURE__ */(0, import_jsx_runtime4.jsx)(_ModalFocusScope, {
    children: /* @__PURE__ */(0, import_jsx_runtime4.jsx)(import_system3.chakra.div, _objectSpread(_objectSpread({}, containerProps), {}, {
      className: "chakra-modal__content-container",
      tabIndex: -1,
      __css: dialogContainerStyles,
      children: /* @__PURE__ */(0, import_jsx_runtime4.jsx)(ModalTransition, _objectSpread(_objectSpread({
        preset: motionPreset,
        motionProps: motionProps,
        className: _className
      }, dialogProps), {}, {
        __css: dialogStyles,
        children: children
      }))
    }))
  });
});

_ModalContent.displayName = "ModalContent"; // src/modal-body.tsx

var import_shared_utils3 = require("@chakra-ui/shared-utils");

var import_system4 = require("@chakra-ui/system");

var import_react5 = require("react");

var import_jsx_runtime5 = require("react/jsx-runtime");

var _ModalBody = (0, import_system4.forwardRef)(function (props, ref) {
  var className = props.className,
      rest = _objectWithoutProperties(props, _excluded3);

  var _useModalContext5 = _useModalContext(),
      bodyId = _useModalContext5.bodyId,
      setBodyMounted = _useModalContext5.setBodyMounted;

  (0, import_react5.useEffect)(function () {
    setBodyMounted(true);
    return function () {
      return setBodyMounted(false);
    };
  }, [setBodyMounted]);

  var _className = (0, import_shared_utils3.cx)("chakra-modal__body", className);

  var styles = _useModalStyles();

  return /* @__PURE__ */(0, import_jsx_runtime5.jsx)(import_system4.chakra.div, _objectSpread(_objectSpread({
    ref: ref,
    className: _className,
    id: bodyId
  }, rest), {}, {
    __css: styles.body
  }));
});

_ModalBody.displayName = "ModalBody"; // src/modal-close-button.tsx

var import_close_button = require("@chakra-ui/close-button");

var import_shared_utils4 = require("@chakra-ui/shared-utils");

var import_system5 = require("@chakra-ui/system");

var import_jsx_runtime6 = require("react/jsx-runtime");

var _ModalCloseButton = (0, import_system5.forwardRef)(function (props, ref) {
  var onClick = props.onClick,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded4);

  var _useModalContext6 = _useModalContext(),
      onClose = _useModalContext6.onClose;

  var _className = (0, import_shared_utils4.cx)("chakra-modal__close-btn", className);

  var styles = _useModalStyles();

  return /* @__PURE__ */(0, import_jsx_runtime6.jsx)(import_close_button.CloseButton, _objectSpread({
    ref: ref,
    __css: styles.closeButton,
    className: _className,
    onClick: (0, import_shared_utils4.callAllHandlers)(onClick, function (event) {
      event.stopPropagation();
      onClose();
    })
  }, rest));
});

_ModalCloseButton.displayName = "ModalCloseButton"; // src/modal-footer.tsx

var import_shared_utils5 = require("@chakra-ui/shared-utils");

var import_system6 = require("@chakra-ui/system");

var import_jsx_runtime7 = require("react/jsx-runtime");

var _ModalFooter = (0, import_system6.forwardRef)(function (props, ref) {
  var className = props.className,
      rest = _objectWithoutProperties(props, _excluded5);

  var _className = (0, import_shared_utils5.cx)("chakra-modal__footer", className);

  var styles = _useModalStyles();

  var footerStyles = _objectSpread({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end"
  }, styles.footer);

  return /* @__PURE__ */(0, import_jsx_runtime7.jsx)(import_system6.chakra.footer, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    __css: footerStyles,
    className: _className
  }));
});

_ModalFooter.displayName = "ModalFooter"; // src/modal-header.tsx

var import_shared_utils6 = require("@chakra-ui/shared-utils");

var import_system7 = require("@chakra-ui/system");

var import_react6 = require("react");

var import_jsx_runtime8 = require("react/jsx-runtime");

var _ModalHeader = (0, import_system7.forwardRef)(function (props, ref) {
  var className = props.className,
      rest = _objectWithoutProperties(props, _excluded6);

  var _useModalContext7 = _useModalContext(),
      headerId = _useModalContext7.headerId,
      setHeaderMounted = _useModalContext7.setHeaderMounted;

  (0, import_react6.useEffect)(function () {
    setHeaderMounted(true);
    return function () {
      return setHeaderMounted(false);
    };
  }, [setHeaderMounted]);

  var _className = (0, import_shared_utils6.cx)("chakra-modal__header", className);

  var styles = _useModalStyles();

  var headerStyles = _objectSpread({
    flex: 0
  }, styles.header);

  return /* @__PURE__ */(0, import_jsx_runtime8.jsx)(import_system7.chakra.header, _objectSpread(_objectSpread({
    ref: ref,
    className: _className,
    id: headerId
  }, rest), {}, {
    __css: headerStyles
  }));
});

_ModalHeader.displayName = "ModalHeader"; // src/modal-overlay.tsx

var import_shared_utils7 = require("@chakra-ui/shared-utils");

var import_system8 = require("@chakra-ui/system");

var import_transition2 = require("@chakra-ui/transition");

var import_framer_motion4 = require("framer-motion");

var import_jsx_runtime9 = require("react/jsx-runtime");

var MotionDiv = (0, import_system8.chakra)(import_framer_motion4.motion.div);

var _ModalOverlay = (0, import_system8.forwardRef)(function (props, ref) {
  var className = props.className,
      transition = props.transition,
      _motionProps = props.motionProps,
      rest = _objectWithoutProperties(props, _excluded7);

  var _className = (0, import_shared_utils7.cx)("chakra-modal__overlay", className);

  var styles = _useModalStyles();

  var overlayStyle = _objectSpread({
    pos: "fixed",
    left: "0",
    top: "0",
    w: "100vw",
    h: "100vh"
  }, styles.overlay);

  var _useModalContext8 = _useModalContext(),
      motionPreset = _useModalContext8.motionPreset;

  var defaultMotionProps = motionPreset === "none" ? {} : import_transition2.fadeConfig;
  var motionProps = _motionProps || defaultMotionProps;
  return /* @__PURE__ */(0, import_jsx_runtime9.jsx)(MotionDiv, _objectSpread(_objectSpread({}, motionProps), {}, {
    __css: overlayStyle,
    ref: ref,
    className: _className
  }, rest));
});

_ModalOverlay.displayName = "ModalOverlay"; // src/alert-dialog.tsx

var import_jsx_runtime10 = require("react/jsx-runtime");

function _AlertDialog(props) {
  var leastDestructiveRef = props.leastDestructiveRef,
      rest = _objectWithoutProperties(props, _excluded8);

  return /* @__PURE__ */(0, import_jsx_runtime10.jsx)(_Modal, _objectSpread(_objectSpread({}, rest), {}, {
    initialFocusRef: leastDestructiveRef
  }));
}

var _AlertDialogContent = (0, import_system9.forwardRef)(function (props, ref) {
  return /* @__PURE__ */(0, import_jsx_runtime10.jsx)(_ModalContent, _objectSpread({
    ref: ref,
    role: "alertdialog"
  }, props));
}); // src/drawer.tsx


var import_react_context2 = require("@chakra-ui/react-context");

var import_system10 = require("@chakra-ui/system");

var import_jsx_runtime11 = require("react/jsx-runtime");

var _ref13 = (0, import_react_context2.createContext)(),
    _ref14 = _slicedToArray(_ref13, 2),
    DrawerContextProvider = _ref14[0],
    _useDrawerContext = _ref14[1];

var placementMap = {
  start: {
    ltr: "left",
    rtl: "right"
  },
  end: {
    ltr: "right",
    rtl: "left"
  }
};

function getDrawerPlacement(placement, dir) {
  var _a, _b;

  if (!placement) return;
  return (_b = (_a = placementMap[placement]) == null ? void 0 : _a[dir]) != null ? _b : placement;
}

function _Drawer(props) {
  var _a;

  var isOpen = props.isOpen,
      onClose = props.onClose,
      _props$placement = props.placement,
      placementProp = _props$placement === void 0 ? "right" : _props$placement,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded9);

  var theme = (0, import_system10.useTheme)();
  var drawerStyleConfig = (_a = theme.components) == null ? void 0 : _a.Drawer;
  var placement = getDrawerPlacement(placementProp, theme.direction);
  return /* @__PURE__ */(0, import_jsx_runtime11.jsx)(DrawerContextProvider, {
    value: {
      placement: placement
    },
    children: /* @__PURE__ */(0, import_jsx_runtime11.jsx)(_Modal, _objectSpread(_objectSpread({
      isOpen: isOpen,
      onClose: onClose,
      styleConfig: drawerStyleConfig
    }, rest), {}, {
      children: children
    }))
  });
} // src/drawer-content.tsx


var import_shared_utils8 = require("@chakra-ui/shared-utils");

var import_system11 = require("@chakra-ui/system");

var import_transition3 = require("@chakra-ui/transition");

var import_jsx_runtime12 = require("react/jsx-runtime");

var MotionDiv2 = (0, import_system11.chakra)(import_transition3.Slide);

var _DrawerContent = (0, import_system11.forwardRef)(function (props, ref) {
  var className = props.className,
      children = props.children,
      motionProps = props.motionProps,
      rootProps = props.containerProps,
      rest = _objectWithoutProperties(props, _excluded10);

  var _useModalContext9 = _useModalContext(),
      getDialogProps = _useModalContext9.getDialogProps,
      getDialogContainerProps = _useModalContext9.getDialogContainerProps,
      isOpen = _useModalContext9.isOpen;

  var dialogProps = getDialogProps(rest, ref);
  var containerProps = getDialogContainerProps(rootProps);

  var _className = (0, import_shared_utils8.cx)("chakra-modal__content", className);

  var styles = _useModalStyles();

  var dialogStyles = _objectSpread({
    display: "flex",
    flexDirection: "column",
    position: "relative",
    width: "100%",
    outline: 0
  }, styles.dialog);

  var dialogContainerStyles = _objectSpread({
    display: "flex",
    width: "100vw",
    height: "$100vh",
    position: "fixed",
    left: 0,
    top: 0
  }, styles.dialogContainer);

  var _useDrawerContext2 = _useDrawerContext(),
      placement = _useDrawerContext2.placement;

  return /* @__PURE__ */(0, import_jsx_runtime12.jsx)(_ModalFocusScope, {
    children: /* @__PURE__ */(0, import_jsx_runtime12.jsx)(import_system11.chakra.div, _objectSpread(_objectSpread({}, containerProps), {}, {
      className: "chakra-modal__content-container",
      __css: dialogContainerStyles,
      children: /* @__PURE__ */(0, import_jsx_runtime12.jsx)(MotionDiv2, _objectSpread(_objectSpread({
        motionProps: motionProps,
        direction: placement,
        in: isOpen,
        className: _className
      }, dialogProps), {}, {
        __css: dialogStyles,
        children: children
      }))
    }))
  });
});

_DrawerContent.displayName = "DrawerContent"; // Annotate the CommonJS export names for ESM import in node:

0 && (module.exports = {
  AlertDialog: _AlertDialog,
  AlertDialogBody: AlertDialogBody,
  AlertDialogCloseButton: AlertDialogCloseButton,
  AlertDialogContent: _AlertDialogContent,
  AlertDialogFooter: AlertDialogFooter,
  AlertDialogHeader: AlertDialogHeader,
  AlertDialogOverlay: AlertDialogOverlay,
  Drawer: _Drawer,
  DrawerBody: DrawerBody,
  DrawerCloseButton: DrawerCloseButton,
  DrawerContent: _DrawerContent,
  DrawerFooter: DrawerFooter,
  DrawerHeader: DrawerHeader,
  DrawerOverlay: DrawerOverlay,
  Modal: _Modal,
  ModalBody: _ModalBody,
  ModalCloseButton: _ModalCloseButton,
  ModalContent: _ModalContent,
  ModalContextProvider: _ModalContextProvider,
  ModalFocusScope: _ModalFocusScope,
  ModalFooter: _ModalFooter,
  ModalHeader: _ModalHeader,
  ModalOverlay: _ModalOverlay,
  useDrawerContext: _useDrawerContext,
  useModal: _useModal,
  useModalContext: _useModalContext,
  useModalManager: _useModalManager,
  useModalStyles: _useModalStyles
});